import { Button, Flex, Text } from "@chakra-ui/react";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";

interface SimplePaginationProps {
  count: number;
  page: number;

  onPageChange: (page: number) => void;
}
const SimplePagination = (props: SimplePaginationProps) => {
  const { count, page, onPageChange } = props;

  const handlePageChange = (newPage: number) =>
    newPage > count || newPage < 1 ? undefined : onPageChange(newPage);

  return (
    <Flex
      align="center"
      pt="20px"
      borderTop={"1px solid rgba(240, 237, 236, 0.6)"}
      justify={"space-between"}
      fontFamily={"'Inter', sans-serif"}
    >
      <Button
        variant={"unstyled"}
        border={" 1px solid rgba(240, 237, 236, 0.6)"}
        boxShadow={"0px 1px 2px rgba(16, 24, 40, 0.05)"}
        borderRadius={"8px"}
        width={"36px"}
        height={"36px"}
        disabled={page === 1}
        pl={"8.5px"}
        onClick={() => handlePageChange(page - 1)}
        _disabled={{
          border: "1px solid rgba(13, 48, 80, 0.2)",
        }}
        textAlign={"center"}
      >
        <ArrowLeftIcon
          width="20px"
          height="20px"
          color={page === 1 ? "rgba(13, 48, 80, 0.2)" : "v2.blue.100"}
        />
      </Button>
      <Text fontSize={"14px"} lineHeight={"20px"} color="rgba(13, 48, 80, 0.8)">
        Page {page} of {count}
      </Text>

      <Button
        variant={"unstyled"}
        border={" 1px solid rgba(240, 237, 236, 0.6)"}
        boxShadow={"0px 1px 2px rgba(16, 24, 40, 0.05)"}
        width={"36px"}
        height={"36px"}
        borderRadius={"8px"}
        pl={"8.5px"}
        _disabled={{
          border: "1px solid rgba(13, 48, 80, 0.2)",
        }}
        disabled={page === count}
        onClick={() => handlePageChange(page + 1)}
      >
        <ArrowRightIcon
          width="20px"
          height="20px"
          color={page === count ? "rgba(13, 48, 80, 0.2)" : "v2.blue.100"}
        />
      </Button>
    </Flex>
  );
};

export default SimplePagination;
